import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { bothSideScrollSubTitle, bothSideScroll } from "../../../../Data/BonusUiData/ScrollbarData";
import { BothSideScrollbarTitle } from "../../../../Utils/Constants";
import ScrollBar from "react-perfect-scrollbar";

export default function BothSideScrollbar() {
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={BothSideScrollbarTitle} subTitle={bothSideScrollSubTitle} />
        <CardBody>
          <div className="scroll-bar-wrap">
            <ScrollBar className="visible-scroll always-visible scroll-demo custom-container">
              <div className="horz-scroll-content scroll-content-width">
                <Row>
                  {bothSideScroll &&
                    bothSideScroll.map((item, index) => (
                      <Col sm={3} key={index}>
                        {item.text}
                      </Col>
                    ))}
                </Row>
              </div>
            </ScrollBar>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
